<script>
import { Article } from '@/api'
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'
import { get } from 'lodash'

export default {
  extends: BaseWidgetForm,
  data() {
    return {
      arrayFields: ['items']
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Tytuł',
              modelPath: [this, 'form', 'title'],
              multilingual: true
            }),
            new fields.Header({
              text: 'Slajdy'
            }),
            new fields.Formset({
              modelPath: [this, 'form', 'items'],
              items: this.form.items.map((item, i) => {
                return {
                  headerLabel: get(item, ['title_en']),
                  fields: [
                    new fields.Input({
                      label: 'Tytuł',
                      modelPath: [this, 'form', 'items', i, 'title'],
                      multilingual: true
                    }),
                    new fields.ForeignKey({
                      service: Article,
                      label: 'Artykuł',
                      modelPath: [this, 'form', 'items', i, 'article'],
                      labelField: 'title_en',
                      required: true
                    }),
                    new fields.Image({
                      label: 'Zdjęcie',
                      modelPath: [this, 'form', 'items', i, 'image'],
                      required: true
                    }),
                    new fields.Select({
                      label: 'Rozmiar',
                      modelPath: [this, 'form', 'items', i, 'size'],
                      options: [
                        { label: 'Mały', value: 'small' },
                        { label: 'Średni', value: 'medium' },
                        { label: 'Duży', value: 'big' }
                      ]
                    })
                  ]
                }
              })
            })
          ]
        }
      ]
    }
  }
}
</script>
